import { useState, useEffect } from 'react';
import classes from './GameSetting.module.scss';
import clickSound from '../../assets/sounds/clickSound.mp3';
import { useDispatch, useSelector } from 'react-redux';
import { resetDrawsForGame, saveBet } from '../../store/gameSlice';
import { useTheme } from '../../utils/ThemeContext';
import DragContainer from '../DragContainer/DragContainer';
import clearIcon from '../../assets/images/delete.svg';
import numberDisplay from '../../assets/pick3Images/coloredPick3.png';
import circleChoosen from '../../assets/pick3Images/circleChoosen.png';
import diceRandom from '../../assets/images/diceRandom.svg';

export default function GameSetting({
  maxNumbers,
  colorNumbers,
  sound,
  nightMode,
}) {
  const [selectedNumbers, setSelectedNumbers] = useState([]);
  const [selectedGameOption, setSelectedGameOption] = useState('');
  const [selectedBalls, setSelectedBalls] = useState([]);
  const [gameLimits, setGameLimits] = useState({ min: 0, max: 0 });
  const [activeGame, setActiveGame] = useState('');
  const [text, setText] = useState('');
  const dispatch = useDispatch();
  const [colorBetting, setColorBetting] = useState(colorNumbers);
  const [position, setPosition] = useState(0);
  const { theme } = useTheme();

  const gameName = useSelector((state) => state.game.gameName);
  console.log(gameName);

  //pick3
  const numbersPick3 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
  const [, setNumberBetPick3] = useState(0);
  const [numberBet, setNumberBet] = useState(0);
  const [number1, setNumber1] = useState('');
  const [number2, setNumber2] = useState('');
  const [number3, setNumber3] = useState('');
  const [pick3Numbers, setPick3Numbers] = useState([]);

  const numbers = Array.from({ length: maxNumbers }, (_, index) => index + 1);
  const gameTypesObject = [
    { name: 'direct 1', details: '40.0', min: 1, max: 1 },
    { name: 'direct 2', details: '240.0', min: 2, max: 2 },
    { name: 'direct 3', details: '2100.0', min: 3, max: 3 },
    { name: 'direct 4', details: '6000.0', min: 4, max: 4 },
    { name: 'direct 5', details: '44000.0', min: 5, max: 5 },
    { name: 'perm 2', details: '240.0', min: 2, max: 9 },
    { name: 'perm 3', details: '2100.0', min: 3, max: 9 },
    { name: 'banker', details: '4*240.0', min: 1, max: 1 },
  ];

  useEffect(() => {
    if (theme.themeName === 'lotto 4/48') {
      setGameLimits({ min: 4, max: 4 });
    } else if (theme.themeName === 'Lotto 6/49') {
      setGameLimits({ min: 6, max: 6 });
    } else if (theme.themeName === 'lotto 5/90') {
      setGameLimits({ min: 0, max: 0 });
    }
  }, [theme.themeName]);

  useEffect(() => {
    if (theme.selectedColor) {
      document.documentElement.style.setProperty(
        '--selected-color',
        theme.selectedColor,
      );
    }
  }, [theme.selectedColor]);

  useEffect(() => {
    if (activeGame === 'randomBtn') {
      const maxNumber = gameLimits.max;
      const randomNumbers = new Set();
      while (randomNumbers.size < maxNumber) {
        const randomNum = Math.floor(Math.random() * 91);
        randomNumbers.add(randomNum);
      }
      setColorBetting((prevColors) =>
        prevColors.map((colorData) => ({ ...colorData, selected: false })),
      );
      const uniqueRandomNumbersArray = Array.from(randomNumbers);
      setSelectedNumbers(uniqueRandomNumbersArray);
    }
  }, [activeGame, gameLimits.max]);

  const handleNumberClick = (number) => {
    if (sound === true) {
      const audio = new Audio(clickSound);
      audio.play();
    }
    setSelectedNumbers((prevSelected) => {
      if (prevSelected.includes(number)) {
        return prevSelected.filter((n) => n !== number);
      } else if (prevSelected.length < gameLimits.max) {
        return [...prevSelected, number];
      }
      return prevSelected;
    });

    setColorBetting((prevColors) =>
      prevColors.map((colorData) => ({ ...colorData, selected: false })),
    );
  };

  const handleCircleClick = (index) => {
    setSelectedNumbers([]);
    const updatedColors = colorBetting.map((colorData, idx) => {
      if (idx === index) {
        return { ...colorData, selected: !colorData.selected };
      }
      return colorData;
    });
    const countSelectedColors = updatedColors.filter(
      (color) => color.selected,
    ).length;
    if (countSelectedColors > 4) {
      return;
    }
    setColorBetting(updatedColors);
  };

  const handleGameOptionClick = (gameOption, min, max) => {
    setSelectedGameOption(gameOption);
    setActiveGame('');

    if (min === max) {
      setText(`You can choose max ${min} number`);
    } else {
      setText(`You can choose min ${min} numbers and max ${max} numbers`);
    }

    setGameLimits({ min, max });
    setSelectedNumbers([]);

    const randomIndices = new Set();
    while (randomIndices.size < max) {
      randomIndices.add(Math.floor(Math.random() * 90));
    }
    setSelectedBalls([...randomIndices]);
  };

  const randomHandler = () => {
    if (theme.themeName === 'lotto 4/48' || theme.themeName === 'Lotto 6/49') {
      let drawCount;
      let maxRange;
      if (theme.themeName === 'lotto 4/48') {
        drawCount = 4;
        maxRange = 48;
      } else if (theme.themeName === 'Lotto 6/49') {
        drawCount = 6;
        maxRange = 49;
      }
      const randomNumbers = new Set();
      while (randomNumbers.size < drawCount) {
        const randomNum = Math.floor(Math.random() * maxRange) + 1;
        randomNumbers.add(randomNum);
      }
      setColorBetting((prevColors) =>
        prevColors.map((colorData) => ({ ...colorData, selected: false })),
      );

      setSelectedNumbers(Array.from(randomNumbers));
    } else {
      if (!selectedGameOption) return;
      let drawCount;
      let maxRange;
      if (theme.themeName) {
        drawCount = gameLimits.max;
        maxRange = maxNumbers;
      }

      const randomNumbers = new Set();
      while (randomNumbers.size < drawCount) {
        const randomNum = Math.floor(Math.random() * maxRange) + 1;
        randomNumbers.add(randomNum);
      }

      setColorBetting((prevColors) =>
        prevColors.map((colorData) => ({ ...colorData, selected: false })),
      );

      setSelectedNumbers(Array.from(randomNumbers));
    }
  };

  useEffect(() => {
    removeHandlerFunctionOnMount();
  }, [theme]);

  const removeHandlerFunction = () => {
    setSelectedNumbers([]);
    setActiveGame('');
    setSelectedGameOption('');
    setSelectedBalls([]);
    setNumber1('');
    setNumber2('');
    setNumber3('');
    setNumberBetPick3(0);
    setPosition(0);
    setText('');
    dispatch(resetDrawsForGame(theme.themeName));
  };

  const removeHandlerFunctionOnMount = () => {
    setSelectedNumbers([]);
    setActiveGame('');
    setSelectedGameOption('');
    setSelectedBalls([]);
    setNumber1('');
    setNumber2('');
    setNumber3('');
    setNumberBetPick3(0);
    setPosition(0);
    setText('');
  };

  const getColorClass = (number, colorNumbers) => {
    const columnIndex = (number - 1) % 10;
    const colorClass = colorNumbers[columnIndex].color;
    return colorClass ? classes[colorClass] : '';
  };

  const handleBetChange = (value) => {
    setNumberBet(value);
  };

  const generateRandom = () => {
    const min = 0;
    const max = 9;
    const rand1 = Math.floor(Math.random() * (max - min + 1)) + min;
    const rand2 = Math.floor(Math.random() * (max - min + 1)) + min;
    const rand3 = Math.floor(Math.random() * (max - min + 1)) + min;

    setNumber1(rand1);
    setNumber2(rand2);
    setNumber3(rand3);
    setPick3Numbers([rand1, rand2, rand3]);
  };

  const handleNumberClickPick3 = (num) => {
    if (sound === true) {
      const audio = new Audio(clickSound);
      audio.play();
    }

    let newNumber1 = number1;
    let newNumber2 = number2;
    let newNumber3 = number3;

    if (number1 === '') {
      newNumber1 = num;
    } else if (number2 === '') {
      newNumber2 = num;
    } else if (number3 === '') {
      newNumber3 = num;
    }
    setPick3Numbers([newNumber1, newNumber2, newNumber3]);
    setNumber1(newNumber1);
    setNumber2(newNumber2);
    setNumber3(newNumber3);
  };

  const betHandler = () => {
    console.log(gameName);

    if (theme.themeName === 'pick 3') {
      dispatch(
        saveBet(
          selectedGameOption || '',
          pick3Numbers,
          numberBet,
          'pick 3',
          colorNumbers || '',
        ),
      );
    } else if (theme.themeName) {
      dispatch(
        saveBet(
          selectedGameOption || '',
          selectedNumbers,
          numberBet,
          gameName,
          colorNumbers,
        ),
      );
    }

    setSelectedNumbers([]);
    setSelectedGameOption('');
    setSelectedBalls([]);
    setNumberBet(0);
    setNumber1('');
    setNumber2('');
    setNumber3('');
    setNumberBetPick3(0);
    setGameLimits({ min: 0, max: 0 });
    setPosition(0);
    setText('');
  };

  return (
    <>
      <div className={classes.allSettings}>
        {theme.themeName === 'pick 3' ? (
          <div
            className={classes.allContPick3}
            style={{
              background: nightMode
                ? theme.selectedColor
                : theme.backgroundInside,
            }}
          >
            <div className={classes.topSettings}>
              <div
                className={classes.iconCont}
                onClick={generateRandom}
                disabled={!selectedGameOption}
              >
                <span className={classes.infoInside}>Random</span>
                <img
                  src={diceRandom}
                  alt="dice icon"
                  className={classes.imageColor}
                />
              </div>
              <div className={classes.clearHowtoPlay}>
                <div
                  className={classes.iconCont}
                  onClick={removeHandlerFunction}
                >
                  <span className={classes.infoInside}>Clear</span>
                  <img
                    src={clearIcon}
                    alt="clear icon"
                    className={classes.imageColor}
                  />
                </div>
              </div>
            </div>
            <div className={classes.gamePick3Cont}>
              <div className={classes.allCirclesPick3}>
                <div className={classes.circlesNumberStyle}>
                  <img
                    src={numberDisplay}
                    alt="display icon"
                    className={classes.imagedisplayStyle}
                  />
                  <span className={classes.numbersInside}>
                    {number1 !== null ? number1 : ''}
                  </span>
                </div>
                <div className={classes.circlesNumberStyle}>
                  <img
                    src={numberDisplay}
                    alt="display icon"
                    className={classes.imagedisplayStyle}
                  />
                  <span className={classes.numbersInside}>
                    {number2 !== null ? number2 : ''}
                  </span>
                </div>
                <div className={classes.circlesNumberStyle}>
                  <img
                    src={numberDisplay}
                    alt="display icon"
                    className={classes.imagedisplayStyle}
                  />
                  <span className={classes.numbersInside}>
                    {number3 !== null ? number3 : ''}
                  </span>
                </div>
              </div>
              <div className={classes.circleRandomCont}>
                <div className={classes.numberToChoose}>
                  {numbersPick3.map((num) => {
                    const isDisabled =
                      number1 !== '' && number2 !== '' && number3 !== '';
                    return (
                      <div
                        key={num}
                        className={`${classes.numberItem} ${isDisabled ? classes.disabled : ''}`}
                        onClick={() =>
                          !isDisabled && handleNumberClickPick3(num)
                        }
                      >
                        <img
                          src={circleChoosen}
                          className={classes.chossenNumbersCircles}
                          alt="circle Choosen icon"
                        />
                        <span
                          className={
                            classes.numbersInside + ' ' + classes.smallNumber
                          }
                        >
                          {num}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className={classes.titleStakeCont}>
                <div className={classes.stakeCont}>
                  <span className={classes.stakeTitles}>STAKE</span>
                  <div className={classes.trackSlider}>
                    <DragContainer
                      min={0}
                      max={1000}
                      onBetChange={handleBetChange}
                      position={position}
                      setPosition={setPosition}
                    />
                  </div>
                </div>
              </div>
              <div className={classes.pick3btnCont}>
                <button
                  className={`${classes.bettingBtn} ${classes.btnSecondtStyle} `}
                  style={{
                    backgroundColor: theme.btnsColor,
                    '--hover-color': theme.hoverColor,
                    boxShadow: theme.boxShadow,
                  }}
                  onClick={betHandler}
                >
                  Re-Bet
                </button>
                <button
                  className={`${classes.bettingBtn} ${classes.btnFirstStyle} `}
                  style={{
                    '--hover-color': theme.hoverColor,
                    boxShadow: theme.boxShadow,
                  }}
                  onClick={betHandler}
                >
                  Bet
                </button>
              </div>
            </div>
          </div>
        ) : (
          <>
            {theme.themeName === 'lotto 4/48' ||
            theme.themeName === 'Lotto 6/49' ? (
              ''
            ) : (
              <div className={classes.optionStakeCont}>
                <div
                  className={classes.chosingCont}
                  style={{
                    background: nightMode
                      ? theme.selectedColor
                      : theme.backgroundInside,
                  }}
                >
                  <span className={classes.stakeTitles}>Choose Game Type</span>
                  <div className={classes.gameOptionsGrid}>
                    {gameTypesObject.map((option, key) => (
                      <div
                        key={key}
                        className={`${classes.optionItem}`}
                        onClick={() =>
                          handleGameOptionClick(
                            option.name,
                            option.min,
                            option.max,
                          )
                        }
                        style={{ background: theme.btnsColor }}
                      >
                        <div
                          className={`${classes.circleInside} ${
                            theme.themeName === 'loto4/48' ||
                            theme.themeName === 'Lotto 6/49' ||
                            selectedGameOption === option.name
                              ? classes.optionItemActive
                              : ''
                          }`}
                        />
                        <span className={classes.gameTypeOption}>
                          {option.name}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div className={classes.textPosition}>
                    <span className={classes.textMessageDetails}>{text}</span>
                  </div>
                  <div className={classes.optionGrid}>
                    {Array.from({ length: 90 }, (_, index) => (
                      <div key={index}>
                        <div
                          style={{
                            backgroundColor: selectedBalls.includes(index)
                              ? '#1DB954'
                              : '#235B33',
                            opacity: selectedBalls.includes(index)
                              ? '100%'
                              : '60%',
                          }}
                          className={classes.ballsOption}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <div
                  className={classes.stakeBack}
                  style={{
                    background: nightMode
                      ? theme.selectedColor
                      : theme.backgroundInside,
                  }}
                >
                  <div className={classes.stakeCont}>
                    <span className={classes.stakeTitles}>STAKE</span>
                    <div className={classes.trackSlider}>
                      <DragContainer
                        min={0}
                        max={1000}
                        onBetChange={handleBetChange}
                        position={position}
                        setPosition={setPosition}
                      />
                    </div>
                  </div>
                  <div className={classes.randomeContainer}></div>
                </div>
              </div>
            )}

            <div
              className={
                theme.themeName === 'lotto 5/90'
                  ? classes.allCont
                  : classes.allotherCont
              }
              style={{
                background: nightMode
                  ? theme.selectedColor
                  : theme.backgroundInside,
              }}
            >
              <div className={classes.topSettings}>
                <div
                  className={classes.iconCont}
                  onClick={randomHandler}
                  disabled={selectedGameOption}
                >
                  <span className={classes.infoInside}>Random</span>
                  <img
                    src={diceRandom}
                    alt="dice icon"
                    className={classes.imageColor}
                  />
                </div>

                <div className={classes.clearHowtoPlay}>
                  <div
                    className={classes.iconCont}
                    onClick={removeHandlerFunction}
                  >
                    <span className={classes.infoInside}>Clear</span>
                    <img
                      src={clearIcon}
                      alt="clear icon"
                      className={classes.imageColor}
                    />
                  </div>
                </div>
              </div>
              <div className={classes.detailsPosition}>
                <div className={classes.contDetails}>
                  <div className={classes.gameGrid}>
                    <div>
                      <div className={classes.numbersGrid1}>
                        {colorBetting.map((data, index) => (
                          <div
                            key={index}
                            className={`${classes.circleContainer} ${data.selected ? classes.selected : ''}`}
                          >
                            <div
                              className={classes.circle}
                              style={{
                                border: `2px solid ${data.color}`,
                              }}
                              onClick={() => handleCircleClick(index)}
                            />
                          </div>
                        ))}
                      </div>

                      <div className={classes.numbersGrid}>
                        {numbers.map((number) => (
                          <div
                            key={number}
                            className={`${classes.numbersSpan} ${selectedNumbers.includes(number) ? classes.active : ''} ${getColorClass(number, colorNumbers ? colorNumbers : '')}`}
                            onClick={() => {
                              if (
                                (theme.themeName === 'lotto 4/48' &&
                                  selectedNumbers.length < 4) ||
                                (theme.themeName === 'Lotto 6/49' &&
                                  selectedNumbers.length < 6) ||
                                (theme.themeName !== 'lotto 4/48' &&
                                  theme.themeName !== 'Lotto 6/49' &&
                                  selectedNumbers.length < gameLimits.max) ||
                                selectedNumbers.includes(number)
                              ) {
                                handleNumberClick(number);
                              }
                            }}
                            style={{
                              pointerEvents:
                                (theme.themeName === 'lotto 4/48' &&
                                  selectedNumbers.length >= 4 &&
                                  !selectedNumbers.includes(number)) ||
                                (theme.themeName === 'Lotto 6/49' &&
                                  selectedNumbers.length >= 6 &&
                                  !selectedNumbers.includes(number)) ||
                                (theme.themeName !== 'lotto 4/48' &&
                                  theme.themeName !== 'Lotto 6/49' &&
                                  selectedNumbers.length >= gameLimits.max &&
                                  !selectedNumbers.includes(number))
                                  ? 'none'
                                  : 'auto',

                              opacity:
                                (theme.themeName === 'lotto 4/48' &&
                                  selectedNumbers.length >= 4 &&
                                  !selectedNumbers.includes(number)) ||
                                (theme.themeName === 'Lotto 6/49' &&
                                  selectedNumbers.length >= 6 &&
                                  !selectedNumbers.includes(number)) ||
                                (theme.themeName !== 'lotto 4/48' &&
                                  theme.themeName !== 'Lotto 6/49' &&
                                  selectedNumbers.length >= gameLimits.max &&
                                  !selectedNumbers.includes(number))
                                  ? 0.5
                                  : 1,
                            }}
                          >
                            {number}
                          </div>
                        ))}
                      </div>
                    </div>
                    {theme.themeName === 'lotto 4/48' ||
                    theme.themeName === 'Lotto 6/49' ? (
                      <div className={classes.betOtherGames}>
                        <div className={classes.titleStakeCont}>
                          <div className={classes.stakeCont}>
                            <span className={classes.stakeTitles}>STAKE</span>
                            <div className={classes.trackSlider}>
                              <DragContainer
                                min={0}
                                max={1000}
                                onBetChange={handleBetChange}
                                position={position}
                                setPosition={setPosition}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    <div className={classes.btnsPositionBets}>
                      <button
                        className={`${classes.bettingBtn} ${classes.btnFirstStyle}`}
                        style={{
                          '--hover-color': theme.hoverColor,
                          boxShadow: theme.boxShadow,
                        }}
                        disabled={
                          (theme.themeName !== 'lotto 4/48' &&
                            theme.themeName !== 'Lotto 6/49' &&
                            !selectedGameOption) ||
                          selectedNumbers.length === 0
                        }
                        onClick={betHandler}
                      >
                        Re-Bet
                      </button>
                      <button
                        className={`${classes.bettingBtn} ${classes.btnSecondtStyle}`}
                        style={{
                          background: theme.btnsColor,
                          '--hover-color': theme.hoverColor,
                          boxShadow: theme.boxShadow,
                        }}
                        disabled={
                          (theme.themeName !== 'lotto 4/48' &&
                            theme.themeName !== 'Lotto 6/49' &&
                            !selectedGameOption) ||
                          selectedNumbers.length === 0
                        }
                        onClick={betHandler}
                      >
                        Bet
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
